import { render, staticRenderFns } from "./PartnersTable.vue?vue&type=template&id=392e4c1c&scoped=true&"
import script from "./PartnersTable.vue?vue&type=script&lang=ts&"
export * from "./PartnersTable.vue?vue&type=script&lang=ts&"
import style0 from "./PartnersTable.vue?vue&type=style&index=0&id=392e4c1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392e4c1c",
  null
  
)

export default component.exports